import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Curriculum from './Curriculum';
import { CURRICULUM_ROUTES } from './constants/routes';
import { useAuth } from '../../shared_app/hooks/useAuth';
var CurriculumRoutes = function () {
    var response = useAuth().response;
    if (!response) {
        return null;
    }
    var authorized = response.status;
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [authorized && (_jsxs(_Fragment, { children: [_jsx(Route, { path: CURRICULUM_ROUTES.Teacher, element: _jsx(Curriculum, { authorized: authorized }, void 0) }, void 0), _jsx(Route, { path: CURRICULUM_ROUTES.Supervizor, element: _jsx(Curriculum, { authorized: authorized }, void 0) }, void 0)] }, void 0)), _jsx(Route, { path: CURRICULUM_ROUTES.Anonymous, element: _jsx(Curriculum, { authorized: authorized }, void 0) }, void 0)] }, void 0) }, void 0));
};
export default CurriculumRoutes;
